import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { PropertyLocationScoreTagModel } from 'models';

import { UitkCardTextSegment } from 'uitk-react-cards';

interface LocationScoreProps {
  score: string;
  tags: PropertyLocationScoreTagModel[];
}

export const LocationScore: React.FunctionComponent<LocationScoreProps> = ({ score, tags }) => {
  if ((!score && (tags && tags.length === 0)) || (!score && !tags)) {
    return null;
  }

  return (
    <>
      <UitkCardTextSegment>
        {score && (
          <h5 className="location-title uitk-type-heading-300" data-stid="location-score-title">
            {score}
          </h5>
        )}
        {tags &&
          tags.length > 0 && (
            <div className="all-y-padding-three uitk-type-paragraph-300" data-stid="location-score-tags">
              <p className="all-b-padding-two">
                <LocalizedText message="hotels.infosite.roomInfoDialog.roomDetails.roomscore.detailText" />
              </p>
              <ul className="no-bullet">
                {tags.map((tag, index) => (
                  <li className="all-b-padding-two" key={index} data-stid="location-score-tag">
                    {tag.label}
                  </li>
                ))}
              </ul>
            </div>
          )}
      </UitkCardTextSegment>
    </>
  );
};
